module.exports = __webpack_public_path__ + "static/img/023.6bfe149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/023.png
// module id = ebi4
// module chunks = 1